import React from 'react'
import { Box, Button, Container, Typography } from '@mui/material'

export const defaultErrorHandler = (
  error: Error,
  info: { componentStack: string }
) => {
  console.error(error)
}

type ErrorBoundaryArgs = {
  error: Error
  resetErrorBoundary: () => unknown
}

export const DefaultErrorBoundary = ({
  error,
  resetErrorBoundary
}: ErrorBoundaryArgs) => (
  <Box
    sx={{
      bgcolor: 'background.paper',
      pt: 8,
      pb: 6
    }}
  >
    <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
      <Typography
        component="h1"
        variant="h2"
        align="center"
        color="text.primary"
        gutterBottom
      >
        Error
      </Typography>

      <Typography>Something went wrong!</Typography>

      <Typography paragraph gutterBottom color="error.main">
        {error.message}
      </Typography>

      <Button onClick={resetErrorBoundary}>Try again</Button>
    </Container>
  </Box>
)
